import EventAnalytics, { GrayLog, getGaClientId } from "~/js/utilities/EventAnalytics";
import { PaymentApi } from "~/solidJs/shared/api/PaymentApi";
import { getPrivateMessageFromError } from "~/solidJs/shared/helpers";
import {
	showToastMessage,
	ToastMessageTypes
} from "~/solidJs/widgets/WorkspaceToast/WorkspaceToast";
import type { premiumCheckoutType } from "../../types";

export const checkoutClickHandler = async (props: {
	isTrial?: boolean;
	nameId: string;
	activeInterval: string;
	type?: premiumCheckoutType;
	promoCode?: string;
	clientId?: number;
}) => {
	try {
		let clientId: number | undefined;
		try {
			clientId = await getGaClientId();
			props = { ...props, clientId };
		} catch (e) {
			console.error(e);
			EventAnalytics.sendErrorInfo("error-get-client-id", {
				message: getPrivateMessageFromError(e)
			});
		}
		const start = Date.now();
		GrayLog.debug({
			log_name: "fetch-create-checkout-session",
			isNeedToSendToAnalitics: false,
			message: "Start to fetch signed session"
		});
		const data = await PaymentApi.createCheckoutSession(props);
		const el = Object.assign(document.createElement("a"), {
			target: "_blank",
			rel: "noopener noreferrer",
			href: data.url
		});
		document.body.append(el);
		el.click();
		el.remove();
		EventAnalytics.getCheckoutLink(Date.now() - start);
	} catch (e) {
		EventAnalytics.sendErrorInfo("error-open-premium-modal", {
			message: getPrivateMessageFromError(e),
			...props
		});
		showToastMessage({
			title: "Something went wrong",
			type: ToastMessageTypes.Error
		});
	}
};
